import { render, staticRenderFns } from "./Behavior.vue?vue&type=template&id=74d63236&scoped=true&"
import script from "./Behavior.vue?vue&type=script&lang=js&"
export * from "./Behavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d63236",
  null
  
)

export default component.exports